import {AfterViewInit, Component, inject, ViewChild} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import { TabViewModule } from 'primeng/tabview';
import { RevocacionesFinalizadasComponent } from './revocaciones-finalizadas.component';
import { RevocacionesPendientesComponent } from './revocaciones-pendientes.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-firma-electronica-revocaciones',
  standalone: true,
  imports: [CustomTitle, TranslateModule, TabViewModule,
    RevocacionesFinalizadasComponent, RevocacionesPendientesComponent
  ],
  template:`
  <section class="flex justify-content-center mt-4">
    <div class="card-table col-12 flex flex-column">
        <div class="pt-1">
            <CustomTitle [title]="'msg.firmaElectronicaRevocaciones' | translate" [showTag]="false"
              [styleClass]="'font-principal font-23 app-title-page-color mt-4 text-uppercase font-medium'"/>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <span>
                            {{'common.pendientes' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-revocaciones-pendientes></app-revocaciones-pendientes>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <span>
                            {{'common.finalizados' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-revocaciones-finalizadas></app-revocaciones-finalizadas>
            </p-tabPanel>
        </p-tabView>
    </div>
  </section>
  `
})
export class FirmaElectronicaRevocacionesComponent implements AfterViewInit {
  activeTabIndex: number = 0;

  @ViewChild(RevocacionesPendientesComponent) pendientes !: RevocacionesPendientesComponent;
  @ViewChild(RevocacionesFinalizadasComponent) finalizadas !: RevocacionesFinalizadasComponent;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor() { }

  ngAfterViewInit(): void {
    this.titleService.changeTitle('msg.firmaElectronicaRevocaciones');
    this.pendientes.getRevocacionesPendientes();
  }

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if(this.activeTabIndex === 0){
      this.pendientes.getRevocacionesPendientes();
    }else{
      this.finalizadas.getRevocacionesFinalizadas();
    }
  }
}
